import { render } from "./PdfViewer.vue?vue&type=template&id=5ce9dcb8&scoped=true&ts=true"
import script from "./PdfViewer.vue?vue&type=script&lang=ts"
export * from "./PdfViewer.vue?vue&type=script&lang=ts"

import "./PdfViewer.vue?vue&type=style&index=0&id=5ce9dcb8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ce9dcb8"]])

export default __exports__
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import qInstall from "../../node_modules/@quasar/app-webpack/lib/loaders/runtime.auto-import.js";
qInstall(script, 'components', {QSpinner});
